$(document).ready(function () {
	appendFilter();
	swiperInit();

	//Library init

	$('.product-filter-display .product-filter-wrapper .product-filter-item:nth-child(2) select option:first-child').html('Fee')
	$('.cxo-product-list-detail .product-filter-display .product-filter-wrapper .product-filter-item:nth-child(2) select option:first-child').html('All')

	$('[data-fancybox]').fancybox({
		toolbar: false,
		smallBtn: true,
		afterShow: function (instance, slide) {
			setTimeout(function () {
				slide.$slide.find('.fancybox-close-small').show();
			}, 3000);
		}
	});
	$("[data-fancybox='modal']").fancybox({
		clickOutside: "close",
	});

	$.fancybox.defaults.parentEl = "form"
	if ($("body").hasClass('homepage')) {


	}


	if ($(window).width() < 767) {
		instruryMobileToggle();

	}

	try {

		linkGlobal();

		$('.mobile-global-client').on('click', function () {
			$(this).next().slideToggle();


		})

	} catch (error) {

	}
	cxoDefault();
	// scrollTopForm();
	hamburgerMenu();
	//Declare function Javascript
	tabActive();
	toggleMobileMenu();
	toggleApplyForm();
	//Toggle function
	// watchMore();
	industryWatchMore();
	pluginToggleWatchMore();
	toggleFitler();
	toggleTraining();
	toggleCXOSearch();
	searchBoxToggle();
	// toogleTrainingDisplay();
	//Product function

	// cxoItemToggle();
	triggerCXOProduct();
	// autoHeightIframe();
	moveFormCapcha();
	jQuery(function ($) {
		"use strict";

		var counterUp = window.counterUp["default"]; // import counterUp from "counterup2"

		var $counters = $(".counter");

		/* Start counting, do this on DOM ready or with Waypoints. */
		$counters.each(function (ignore, counter) {
			var waypoint = new Waypoint({
				element: $(this),
				handler: function () {
					counterUp(counter, {
						duration: 5000,
						delay: 16
					});
					this.destroy();
				},
				offset: "bottom-in-view"
			});
		});
	});

	if ($('.product-sort-display ul li').hasClass('hide-list-product-rbnc')) {
		$('.training-coaching-show').addClass('hidden')
	}
	if ($(window).width() > 1024) {

		$('.product-filter-display').scrollToFixed();
		// $('.other-cxo-wrapper').scrollToFixed();
	}


	// var labelCode = $('.job-apply-no-resume .label-code').html()
	$('.job-apply-no-resume .label-code').appendTo('.job-apply-no-resume .frm-captcha')
	$('.swiper-sub-zone-navigation .swiper-slide.active ').each(function () {
		$('.swiper-sub-zone-navigation .swiper-slide.active').click()
	})
	// new Vivus("brand-logo-svg", {
	// 	type: "sync",
	// 	duration: 100,
	// 	start: "autostart",
	// 	animTimingFunction: Vivus.EASE,
	// 	forceRender: !1,
	// 	dashGap: 0,
	// 	selfDestroy: !0
	// }, function () {
	// 	window.console && ($(".cls-1").css("fill", "none"), $(".cls-2").css("fill",
	// 	"#2F456F"), $("path").attr("stroke-width", "0"), $(".cls-1").attr("stroke-width", "20"),
	// 	 $(".cls-2").attr("stroke", "none"),
	// 		$('.loading-circle-wrapper').queue(function (next) {
	// 			$(this).css({
	// 				"opacity": "0",
	// 				"z-index": "-1"
	// 			});
	// 			next();
	// 		})
	// 	)
	// });
	CXOScrollTop();
	// var SwiperSubzone = new Swiper(".swiper-sub-zone-navigation .swiper-container", {
	// 	// spaceBetween: 10,
	// 	// initialSlide: initSlideActive,
	// 	// Optional parameters
	// 	slidesPerView: 'auto',
	// 	speed: 1205,
	// 	navigation: {
	// 		nextEl: ".nav-arrow-next.zone-sub-next",
	// 		prevEl: ".nav-arrow-prev.zone-sub-prev"
	// 	},
	// });
	
	// swiperActiveToLeft()
	moveHTML();
	animateMB();
	var checkNoResult = $('.no-result').length
	if(checkNoResult == 1){
		$('.image-cxo').hide()
		$('.ajax-cxo-submit-resume-2').hide()
		// $('.image-cxo').hide()
	}
});
//Check if windows size large then 1024 then these function will be execute

$(window).bind("load", function () {
	$('.rcRefreshImage').html('');
	$('.rcRefreshImage').on('click', function () {
		$(this).html('')
	});
});

function swiperInit() {

	var initSlideActive = $('.swiper-sub-zone-navigation .swiper-slide.active').index()
	// console.log(initSlideActive)

	// SwiperSubzone.activeIndex
	try {
		var advisorySwiperBusiness = new Swiper(".advisory-swiper-display .swiper-container", {
			// Optional parameters
			touchRatio: 0.2,
			init: false,
			slideToClickedSlide: true,
			speed: 1205,
			spaceBetween: 0,
			autoplay: {
				delay: 3000
			},
			centeredSlides: true,
			breakpointsInverse: true,
			breakpoints: {
				320: {
					slidesPerView: 1,
				},

				1024: {
					slidesPerView: 1,
				},
				1280: {
					slidesPerView: 5,
				}
			},
			navigation: {
				nextEl: ".nav-arrow-next.advisory-sub-next",
				prevEl: ".nav-arrow-prev.advisory-sub-prev"


			},

		})
		advisorySwiperBusiness.on('init', function () {
			advisorySwiperBusiness.slideTo(2);
		});
		advisorySwiperBusiness.init();


	} catch (error) {

	}

	var homerSwiper = new Swiper(".home-banner .swiper-container", {
		// Optional parameters
		slidesPerView: 1,
		speed: 1205,
		autoplay: {
			delay: 3000
		},
		navigation: {
			nextEl: ".nav-arrow-next",
			prevEl: ".swiper-prev-home"
		}
	});


	var topBanner = new Swiper(".top-banner .swiper-container", {
		// Optional parameters
		speed: 1205,
		slidesPerView: 1,
		autoplay: {
			delay: 3000
		}
	});


	var advisorySwiper = new Swiper(".swiper-other-coaching-training .swiper-container", {
		// Optional parameters
		speed: 1205,
		spaceBetween: 30,
		autoplay: {
			delay: 3000
		},
		breakpointsInverse: true,
		breakpoints: {
			320: {
				slidesPerView: 1,
			},

			576: {
				slidesPerView: 2,
			},
			1260: {
				slidesPerView: 4,
			}
		},
		navigation: {
			nextEl: ".nav-arrow-next",
			prevEl: ".nav-arrow-prev"


		},

	});
	var homeBlog = new Swiper(".home-blog .swiper-container", {
		// Optional parameters
		speed: 1205,
		spaceBetween: 30,
		autoplay: {
			delay: 3000
		},
		breakpointsInverse: true,
		breakpoints: {
			320: {
				slidesPerView: 1,
			},

			576: {
				slidesPerView: 2,
			},
			1025: {
				slidesPerView: 3,
			},
			1260: {
				slidesPerView: 4,
			}
		},
		navigation: {
			nextEl: ".nav-arrow-next",
			prevEl: ".nav-arrow-prev"


		},

	});


}



function hamburgerMenu() {
	var $hamburger = $(".main-menu-toggle");
	$hamburger.on("click", function (e) {
		$(this).parent().find('.main-menu-navigation').toggleClass('active')
		$hamburger.find('.hamburger').toggleClass("is-active");
		// Do something else, like open/close menu
	});
}


function linkGlobal() {
	if (window.location.hash) {
		var hash = window.location.hash;
		let offset = 100;
		$('html, body').animate({
			scrollTop: $(hash).offset().top - offset
		}, 800, 'linear');
	}
	//Footer scroll to div smooth
	$(".global-client-display a").on('click', function (event) {

		// Make sure this.hash has a value before overriding default behavior
		if (this.hash !== "") {
			// Prevent default anchor click behavior
			let offset = 150;
			// Store hash
			var hash = this.hash;

			// Using jQuery's animate() method to add smooth page scroll
			// The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
			$('html, body').animate({
				scrollTop: $(hash).offset().top - offset
			}, 800, function () {

				// Add hash (#) to URL when done scrolling (default click behavior)
				window.location.hash = hash;
			});
		} // End if
	});

}

// // Product function
// function cxoItemToggle() {
// 	$(".other-cxo-item").click(function (e) {
// 		e.preventDefault();
// 		let url = $(this).attr('href');
// 		$.ajax({
// 			url: url,
// 			success: function (result) {
// 				let detail = $(result).find('.cxo-information-product-detail');
// 				$('.cxo-information-product-wrapper').html(detail);
// 			}
// 		});
// 	});
// }

function appendFilter() {
	if ($("body").hasClass('training-coaching-detail-section')) {

		$('.product-filter-display').insertAfter('.product-sort-display')
	}
	if ($("body").hasClass('training-display-section')) {
		$('.product-filter-display').insertAfter('.product-sort-display')
	}
	if ($("body").hasClass('about-us-section')) {
		$('.global-client-display').insertAfter('.company-about-display ')
	}
}


function triggerCXOProduct() {
	let item = $('.cxo-detail-submit .other-cxo-wrapper .other-cxo-item');
	if ({})
		item.on('click', function () {
			$(this).addClass('active')
			item.not($(this)).removeClass('active')
		})
	if ($("body").hasClass('cxo-product-list-detail')) {
		$('.product-filter-display').insertAfter('.cxo-detail-submit .container .title-section-wrapper');
		$('.box-submit-resume').appendTo('.cxo-detail-submit .cxo-submit-resume');
		$('.cxo-detail-submit .other-cxo-wrapper .other-cxo-item:first-child').click();
	}
}

//Toggle function

function searchBoxToggle() {
	//Toggle Search
	let searchBox = $(".search-wrapper-popup .searchbox");

	$(".search-toggle").on("click", function () {
		$(this).toggleClass('active')

		if (searchBox.hasClass('open')) {
			searchBox.removeClass("open");
		} else {
			searchBox.toggleClass("active");
			event.preventDefault();
			searchBox.addClass("open");
			$('.search-wrapper-popup .searchbox  > input[type="text"]').focus();
		}
	});

	$(".search-wrapper-popup .searchbox,.search-wrapper-popup .searchbox button.close").on("click keyup", function (event) {
		if (
			event.target == this ||
			event.target.className == "close" ||
			event.keyCode == 27
		) {
			$(this).removeClass("open");
		}
	});

}

function toggleTraining() {
	let trigger = $('.training-coaching-detail .fullcontent h4');

	trigger.on('click', function () {
		if ($(this).hasClass('active')) {
			trigger.removeClass('active')
			trigger.nextAll().slideUp()
		} else {
			trigger.removeClass('active')
			trigger.nextAll().slideUp()
			$(this).addClass('active')
			$(this).nextAll().slideToggle();
		}

	})
}


function toggleCXOSearch() {
	let trigger = $('.figure-cxo-toggle-wrapper .title-wrapper');

	trigger.on('click', function () {
		if ($(this).hasClass('active')) {
			trigger.removeClass('active')
			trigger.next().slideUp()
		} else {
			trigger.removeClass('active')
			trigger.next().slideUp()
			$(this).addClass('active')
			$(this).next().slideToggle();
		}

	})
}

// function toogleTrainingDisplay() {
// 	let trigger = $('.training-coaching-display-2 .title-wrapper');
// 	trigger.on('click', function () {
// 		if ($(this).hasClass('active')) {
// 			trigger.removeClass('active')
// 			trigger.next().slideUp()
// 		} else {
// 			trigger.removeClass('active')
// 			trigger.next().slideUp()
// 			$(this).addClass('active')
// 			$(this).next().slideToggle();
// 		}
// 	})

// }


// Remove when click outside the circle
function toggleFitler() {
	$('.product-filter-toggle').on('click', function () {
		$(this).next().slideToggle();
		$('.product-sort-display').slideToggle()
	})
	$('.product-box-resume-toggle').on('click', function () {
		$('.cxo-submit-resume').toggleClass('active')
	})
	$('.cxo-submit-resume .mb-hide-box-submit-resume').on('click', function(){
		console.log(1200);
		// if($(window).width() < 576){
		console.log(576);
			// cart.removeClass('active')
		// }
	})
}

function tabActive() {
	$(".tab-navigation li a").on("click", function () {
		$(this)
			.parents(".tab-navigation")
			.find("li")
			.removeClass("active");
		$(this)
			.parents("li")
			.addClass("active");

		var display = $(this).attr("data-type");
		$(".tab-item").removeClass("active");
		$("#" + display).addClass("active");
	});
}


function toggleMobileMenu() {
	$(".mobile-toggle").on("click", function () {
		$(".mobile-wrapper").toggleClass("active");
	});
}



function globalDashboard() {
	$(".global-client-wrapper > .global-client-item > .title").click(function (e) {
		e.preventDefault();
		if (!$(this)
			.parent()
			.hasClass("active")
		) {
			$(".global-client-item .content").slideUp();
			$(this)
				.next()
				.slideToggle();
			$(".global-client-item").removeClass("active");
			$(this)
				.parent()
				.addClass("active");
		} else {
			$(this)
				.next()
				.slideToggle();
			$(".global-client-item").removeClass("active");
		}
	});
}


function instruryMobileToggle() {
	$('.company-industry .table-stripe table tr .title').click(function (e) {
		e.preventDefault();
		if (!$(this)
			.parent()
			.hasClass("active")
		) {
			$('.company-industry .table-stripe table tr .hidden-mobile').slideUp();
			$(this)
				.next()
				.slideToggle();
			$('.company-industry .table-stripe table tr').removeClass('active');
			$(this)
				.parent()
				.addClass('active');
		} else {
			$(this)
				.next()
				.slideToggle();
			$('.company-industry .table-stripe table tr').removeClass('active');
		}
	});
}

function toggleApplyForm() {
	$(".apply-form .button-apply a").on("click", function () {
		$(".form-apply").slideToggle();
	});
}

function watchMore() {
	let watchMore = $(".company-advisory-services .btn-view-more");
	let article = $(".company-advisory-services .figure-about-service article");
	let maxHeight = 150;
	let height = 0;
	let cotent = $(".company-advisory-services .figure-about-service article .caption");
	let pArray = $(".company-advisory-services .figure-about-service article .caption").children();

	watchMore.on("click", function () {
		if ($(this).parents('article').hasClass('active')) {

			cotent.css({
				"max-height": 150 + "px"
			});
			article.removeClass("active");
			// $(this).find('a').text("Xem thêm")
		} else {
			$.each(pArray, function (indexInArray, valueOfElement) {
				// height.push(element.height());

				height += $(valueOfElement).height();
			});
			cotent.not($(this).parents("article").find('.caption')).css({
				"max-height": 150 + "px"
			});
			article.not($(this).parents("article")).removeClass("active");
			// $(this).find('a').text("Ẩn đi")
			$(this).parents("article").find('.caption').css({
				"max-height": maxHeight + height + "px"
			});
			$(this).parents("article").addClass("active");
			$("html, body").animate({
				scrollTop: $(this).parents('.col').offset().top - 20
			});
		}

	});
}




function pluginToggleWatchMore() {

	let button = $(".toggle-show-more .btn-show-more");
	let articleWrapper = $(".toggle-show-more article");
	let maxHeight = 150;
	let height = 0;
	let content = $(".toggle-show-more article  .content-height");
	let array = $(".toggle-show-more article  .content-height").children();
	button.on("click", function () {
		if ($(this).parents('article').hasClass('active')) {

			content.css({
				"max-height": 150 + "px"
			});
			articleWrapper.removeClass("active");
			// $(this).find('a').text("Xem thêm")
			$(this).find('.less').removeClass('active')
			$(this).find('.more').addClass('active')
			$(this).removeClass('active')
			
		} else {
			$.each(array, function (indexInArray, valueOfElement) {
				// height.push(element.height());

				height += $(valueOfElement).height();
			});
			content.not($(this).parents("article").find('.content-height')).css({
				"max-height": 150 + "px"
			});
			articleWrapper.not($(this).parents("article")).removeClass("active");
			// $(this).find('a').text("Ẩn đi")
			$(this).parents("article").find('.content-height').css({
				"max-height": maxHeight + height + "px"
			});
			$(this).parents("article").addClass("active");
			$("html, body").animate({
				scrollTop: $(this).parents('.col').offset().top - 120
			});
			$(this).find('.more').removeClass('active')
			$(this).find('.less').addClass('active')
			$(this).addClass('active')
			
		}

	});

}


function industryWatchMore() {
	let watchMore = $(".company-industry .project-view-more");
	let article = $(".company-industry .industry-description");
	let maxHeight = 135;
	let height = 0;
	let cotent = $(".company-industry .industry-description");
	let pArray = $(".company-industry  .industry-description").children();
	let totalHeight = 0;
	let button = $(".project-view-more .btn-view-more");

	$(".company-industry .table-stripe .industry-description").children().each(function () {
		totalHeight = totalHeight + $(this).outerHeight(true);
	});
	if (totalHeight > 135) {
		watchMore.on("click", function () {
			console.log(1)
			if ($(this).prev(".industry-description").hasClass('active')) {
				console.log(2)
				cotent.css({
					"max-height": 135 + "px"
				});
				article.removeClass("active");
				// $(this).find('a').text("Xem thêm")
				$(this).find('.btn-view-more').text('Show more').removeClass('active')

			} else {
				console.log(3)
				$.each(pArray, function (indexInArray, valueOfElement) {
					// height.push(element.height());

					height += $(valueOfElement).height();
				});
				cotent.not($(this).prev(".industry-description")).css({
					"max-height": 135 + "px"
				});
				article.not($(this).prev(".industry-description")).removeClass("active");
				// $(this).find('a').text("Ẩn đi")
				$(this).prev(".industry-description").css({
					"max-height": maxHeight + height + "px"
				});
				$('.project-view-more .btn-view-more').text('Show more').removeClass('active')
				$(this).find('.btn-view-more').text('View less').addClass('active')
				$(this).prev(".industry-description").addClass("active");
				$("html, body").animate({
					scrollTop: $(this).parents('tr').offset().top - 30
				});
			}


		});
	} else {
		button.css({
			opacity: '0',
			'pointer-events': 'none'
		});
	}
}

function cxoDefault() {
	$('.other-cxo-wrapper .other-cxo-item').on('click', function () {

		// $(".cxo-detail-information").show();
		// $(".cxo-fullcontent").show();
		// $(".form-apply").hide(); 
	})
	// }
}
$(window).bind("load", function () {
	$('.rcRefreshImage').html('');
	$('.rcRefreshImage').on('click', function () {
		$(this).html('')
	});
});

function preloader() {

}

function autoHeightIframe() {
	$('.training-coaching-form .frm-btnwrap .frm-btn input').on('click', function () {
		console.log(1)
		$('.training-coaching-form-display').addClass('autoHeightIframe')
	})
}

function scrollTopForm() {
	$('.cxo-information-product-detail input[type=submit]').on('click', function () {
		$('html, body').animate({
			scrollTop: $(".cxo-information-product-detail").offset().top - 100
		}, 2000);
	})
}

function CXOScrollTop() {
	let link = $('.other-cxo-wrapper .other-cxo-item')
	link.on('click', function () {
		$('html, body').animate({
			scrollTop: $('.cxo-information-product-wrapper').offset().top - $('header').height() - 100
		}, 1000)
	})
}

function moveFormCapcha() {
	let capchaForm = $('.cxo-information-product-detail .job-apply-no-resume .frm-captcha')
	capchaForm.addClass('col w-full')
	capchaForm.appendTo('.job-apply-no-resume .wrap-form .wrap-form .row')
}


function moveHTML(){
	let element = $('.product-detail-page .ajax-cxo-submit-resume-2')
	let eleImage = $('.image-cxo')
	element.appendTo('.main-cxo-detail-relay-left .cxo-submit-resume')
	eleImage.appendTo('.image-cxo-wrapper')
}
function animateMB(){
	let buttonAdd = $('.cxo-detail-information .btn-cart .btn-add-cart')
	let cart = $('.cxo-submit-resume')
	buttonAdd.on('click', function(){
		if($(window).width() < 576){
			cart.addClass('active')
		}
	})
	
}
